<div class="esf-overlay esf-js-closeModal" style="top: 0;" [ngClass]="{'-is-open': passwordResetModal}">
  <div class="esf-modal" [ngClass]="{'-is-open': passwordResetModal}">
    <header class="esf-modal__header">
      <h3 i18n='Modal title@@general.modalTitle.resetPassword'>Reset password</h3>
    </header>
    <div class="esf-modal__inner">
      <form [formGroup]="passwordResetForm" (ngSubmit)="onSubmit()" id="passwordResetForm">
        <div app-form-field-password
             [label]="flTranslations.i18nPassword"
             [id]="'password2'"
             [control]="passwordResetForm.controls['password']">
        </div>
        <br>
        <div app-form-field-password
             [label]="flTranslations.i18nRepeatPassword"
             [id]="'password2Repeat'"
             [control]="passwordResetForm.controls['passwordRepeat']">
        </div>
        <div *ngIf="passwordResetForm.hasError('passwordNotSame') && submitted"
             i18n='Validation error@@general.validation.passwordsNotMatch'
             class="esf-form-validation__message">The passwords do not match</div>
      </form>
      <hr style="margin-top: 30px;">
      <div class="esf-text-block">
        <small i18n='A bullet list header@@general.bullet.passwordRequirements'>Password requirements</small>
        <ul class="esf-list esf-list--bulleted">
          <li i18n='A bullet list item@@general.bullet.8To32CharactersLong'
              class="esf-list__item esf-list--bulleted__item">The password must be between 8 and 32 characters long</li>
          <li i18n='A bullet list item@@general.bullet.identicalCharacterNotMoreThanTwice'
              class="esf-list__item esf-list--bulleted__item">An identical character may not follow more than twice ('111' is e.g. not allowed)</li>
          <li class="esf-list__item esf-list--bulleted__item">
            <span i18n='A bullet list item@@general.bullet.atLeast3MustMatch'>At least 3 of these must match</span>
            <ul class="esf-list esf-list--bulleted">
              <li i18n='A bullet list item@@general.bullet.atLeastOneCapital'
                  class="esf-list__item esf-list--bulleted__item">At least one capital letter (A-Z)</li>
              <li i18n='A bullet list item@@general.bullet.atLeastOneLowercase'
                  class="esf-list__item esf-list--bulleted__item">At least one lowercase letter (a-z)</li>
              <li i18n='A bullet list item@@general.bullet.atLeastOneNum'
                  class="esf-list__item esf-list--bulleted__item">At least one number (0-9)</li>
              <li i18n='A bullet list item@@general.bullet.atLeastOneSpecial'
                  class="esf-list__item esf-list--bulleted__item">At least one special character</li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <footer class="esf-modal__footer">
      <div class="esf-submit-row">
        <div class="esf-submit-row__item">
          <button class="esf-button esf-button--standard esf-button--filled" *ngIf="!loadingModal" form="passwordResetForm">{{ buttonsTranslations.i18nSubmit }}</button>
          <div class="esf-spinner flex-container" *ngIf="loadingModal">
            <div class="row">
              <span class="esf-spinner__bounce esf-spinner__bounce--1"></span>
              <span class="esf-spinner__bounce esf-spinner__bounce--2"></span>
              <span class="esf-spinner__bounce esf-spinner__bounce--3"></span>
            </div>
          </div>
        </div>
        <div class="esf-submit-row__item">
          <button class="esf-button esf-button--standard esf-button--outlined" (click)="passwordResetModal = false">{{ buttonsTranslations.i18nBack }}</button>
        </div>
      </div>
    </footer>
    <div class="esf-modal__close" (click)="passwordResetModal = false">
      <svg class="esf-icon esf-icon--darker" width="24" height="24">
        <use xlink:href="#esf-icon-close"></use>
      </svg>
    </div>
  </div>
</div>
